import React from 'react';

function Chat() {
    return (
        <section className="tc-chat-style1">
            <div className="container">
                <div className="content">
                    <a href="mailto:info@aktoprakvillas.com" className="xl-text js-splittext-lines">
                        info@tetra-yapi.com
                    </a>
                    <h5 className="mb-50 lh-5">
                        Hayalinizdeki yaşam için <br /> size yardımcı olalım
                    </h5>
                </div>
            </div>
            <img
                src="/innerpages/assets/img/c_line4.png"
                alt=""
                className="c-line wow"
            />
        </section>
    );
}

export default Chat;